import _extends from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { animated, useTransition } from 'react-spring';
import { connect } from 'react-redux';
import { FullDisplay, Navigation, Item, PhotosContainer, Wrapper, Counter, CarouselGlobalStyle } from './styles';
import ArrowLeft from '@spa/shared/svg/arrow-left';
import ArrowRight from '@spa/shared/svg/arrow-right';
import { MediaContext } from '@spa/shared/contexts/media';
import { UNIT_TYPE_TRANSLATIONS } from '@spa/shared/constants/translations';
import { useSwipe } from '@spa/shared/hooks/swipe';
import { theme } from '@spa/offer/theme';
import { carousel } from '@spa/shared/animations/carousel';
import { trackPhotosCarouselOpened } from '@spa/offer/store/actions/tracking';
import { modalIds } from '../../modal-displayer';
var PhotosCarousel = function PhotosCarousel(_ref) {
  var _ref$photos = _ref.photos,
    photos = _ref$photos === void 0 ? [] : _ref$photos,
    _ref$carouselIndex = _ref.carouselIndex,
    carouselIndex = _ref$carouselIndex === void 0 ? 0 : _ref$carouselIndex,
    trackPhotosCarouselOpenedAction = _ref.trackPhotosCarouselOpenedAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  var _useState = useState(300),
    height = _useState[0],
    setHeight = _useState[1];
  var _useState2 = useState(300),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = useState(window.innerWidth),
    windowWidth = _useState3[0],
    setWindowWidth = _useState3[1];
  var _useState4 = useState(window.innerHeight),
    windowHeight = _useState4[0],
    setWindowHeight = _useState4[1];
  var validPhotos = useMemo(function () {
    return photos.filter(function (_ref2) {
      var isPlaceholder = _ref2.isPlaceholder;
      return !isPlaceholder;
    });
  }, [photos]);
  var _useSwipe = useSwipe({
      slides: validPhotos,
      active: carouselIndex
    }),
    _useSwipe2 = _slicedToArray(_useSwipe, 5),
    _useSwipe2$ = _useSwipe2[0],
    active = _useSwipe2$.active,
    translate = _useSwipe2$.translate,
    setActive = _useSwipe2[1],
    goLeft = _useSwipe2[2],
    goRight = _useSwipe2[3],
    handlers = _useSwipe2[4];
  var photosRef = useRef();
  var navigationRef = useRef();
  useEffect(function () {
    var isLandscape = window.matchMedia('(orientation: landscape)').matches;
    if (isLandscape && is.mobile) {
      document.querySelector('#photos-modal-wrapper').scrollTo(0, 0);
      return;
    }
    if (photosRef.current) {
      setHeight(photosRef.current.offsetHeight);
      setWidth(photosRef.current.offsetWidth);
      photosRef.current.focus();
    }
    trackPhotosCarouselOpenedAction();
  }, [photosRef.current, windowWidth, windowHeight]);
  useEffect(function () {
    var isLandscape = window.matchMedia('(orientation: landscape)').matches;
    if (isLandscape && is.mobile) {
      return;
    }
    var moveToActivePhoto = function moveToActivePhoto() {
      if (navigationRef.current) {
        var activeElement = navigationRef.current.querySelector('.active');
        if (activeElement) {
          activeElement.scrollIntoView({
            behavior: 'smooth',
            inline: 'center'
          });
        }
      }
    };
    var timeUntilMove = setTimeout(moveToActivePhoto, 300);
    return function () {
      return clearTimeout(timeUntilMove);
    };
  }, [active, is.mobile]);
  useEffect(function () {
    var handleResize = function handleResize() {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  if (!validPhotos.length) {
    return null;
  }
  var keyEvents = {
    ArrowLeft: goLeft,
    37: goLeft,
    ArrowRight: goRight,
    39: goRight
  };
  var handleKeyPress = function handleKeyPress(event) {
    var action = keyEvents[event.key] || keyEvents[event.keyCode] || function () {};
    action(event);
  };
  var transitions = useTransition(validPhotos[active], carousel(translate));
  return __jsx(Wrapper, {
    className: 'photos-carousel',
    onKeyDown: handleKeyPress,
    tabIndex: 0,
    "data-testid": 'photos-carousel'
  }, __jsx(CarouselGlobalStyle, null), __jsx(FullDisplay, _extends({
    ref: photosRef
  }, handlers), __jsx("button", {
    className: 'left',
    onClick: goLeft
  }, __jsx(ArrowLeft, {
    color: theme.photosModal.carouselSection.navigationControls.svgColor
  })), __jsx(PhotosContainer, null, transitions(function (style, item) {
    return __jsx(animated.div, {
      loading: 'lazy',
      key: item.id,
      style: style
    }, __jsx("img", {
      src: item.href,
      alt: "".concat(t(item.roomType)),
      width: width,
      height: height
    }), __jsx(Counter, {
      "data-testid": 'photos-counter'
    }, __jsx("span", null, t(UNIT_TYPE_TRANSLATIONS[validPhotos[active].unitType])), __jsx("span", null, active + 1), " / ", (validPhotos === null || validPhotos === void 0 ? void 0 : validPhotos.length) || 0));
  })), __jsx("button", {
    autoFocus: true,
    className: 'right',
    onClick: goRight
  }, __jsx(ArrowRight, {
    color: theme.photosModal.carouselSection.navigationControls.svgColor
  }))), __jsx(Navigation, {
    ref: navigationRef
  }, validPhotos.map(function (photo, index) {
    return photo.href ? __jsx(Item, {
      className: active === index ? 'active' : '',
      key: "".concat(photo.id, "_").concat(index),
      onClick: function onClick() {
        return setActive(index);
      }
    }, __jsx("img", {
      src: photo.href,
      alt: "".concat(t(photo.roomType))
    })) : null;
  })));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var photos = _ref3.offer.photosModal.photos,
    modals = _ref3.modal.modals;
  var _modals$find = modals.find(function (_ref4) {
      var modalId = _ref4.modalId;
      return modalId === modalIds.PHOTOS_MODAL;
    }),
    _modals$find$selected = _modals$find.selectedPhotoIndex,
    carouselIndex = _modals$find$selected === void 0 ? 0 : _modals$find$selected;
  return {
    photos: photos.filter(function (photo) {
      return !!photo.href;
    }),
    carouselIndex: carouselIndex
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackPhotosCarouselOpenedAction: function trackPhotosCarouselOpenedAction() {
      return dispatch(trackPhotosCarouselOpened());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PhotosCarousel);